import { render, staticRenderFns } from "./BandwidthSms.vue?vue&type=template&id=2c3cecf0"
import script from "./BandwidthSms.vue?vue&type=script&lang=js"
export * from "./BandwidthSms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports